<div class="row justify-content-center text-center">
  <div class="col-xl-7 col-lg-8 col-md-10">
    <ng-content></ng-content>
  </div>
</div>
